var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"title"}},[_c('van-nav-bar',{attrs:{"title":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }